import { render, staticRenderFns } from "./updateManageNotification.vue?vue&type=template&id=6bf5f7b8&"
import script from "./updateManageNotification.vue?vue&type=script&lang=js&"
export * from "./updateManageNotification.vue?vue&type=script&lang=js&"
import style0 from "./updateManageNotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports